import { render, staticRenderFns } from "./PortalErrors.vue?vue&type=template&id=3cccd3ac&"
import script from "./PortalErrors.vue?vue&type=script&lang=js&"
export * from "./PortalErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports